<template>
  <div class="colleges-index">
    <!-- HEADER -->
    <section
      class="module module-header bg-dark bg-dark-50"
      data-background="/assets/images/section-7.jpg"
      style="background-image: url(/assets/images/orange-clouds.jpg);"
    >
      <div class="container">
        <!-- MODULE TITLE -->
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2">
            <h1 class="module-title font-alt align-center">
              <i class="fa fa-cube"></i>
              <p></p>
              <strong>Art U</strong>
            </h1>

            <div class="module-subtitle font-inc align-center">
              <div class="post-meta font-inc">
                Eight Schools | Dozens of Artists | Hundreds of Artworks |
                Thousands of Art-Lovers
              </div>
              <div class="post-meta font-inc"></div>
            </div>
          </div>
        </div>
        <!-- /MODULE TITLE -->
      </div>
    </section>
    <!-- /HEADER -->
    <!-- PORTFOLIO DESCRIPTION -->
    <section class="module-small p-b-70">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="work-details">
              <h3 class="work-details-title font-alt">Our Mission</h3>
              <p>
                <strong>Art U</strong> provides a platform for college and
                university student artists to showcase their artworks, represent
                their schools, and accrue followings through social engagement
                with other artists, curators, collectors, and everyday art
                lovers. Art U is a space where student artists across the United
                States can connect with a global community.
              </p>
              <p>
                We are a mission-driven organization seeking to uplift the next
                generation of artists whose contributions will undoubtedly
                inspire and create change in our world. The Art U Team is as
                passionate about creating, discovering, collecting, and sharing
                art as our community, and we are eager to welcome new members.
                <!-- Note: This should probably be "as is our community", unless im saying the Art U team is as passionate about art as we are about our community -->
              </p>
              <p>
                The evolution of art is a state of constant revolution. Art will
                grow, adapt, and exist despite anything, and as a powerful agent
                of change. The rapid, infinite, and decentralized evolution of
                art is ongoing indefinately. Art U simply seeks to facilitate a
                way for those participating to come together and witness this
                process.
              </p>
            </div>
          </div>

          <div class="col-sm-6">
            <blockquote class="font-serif align-right">
              <br /><br />
              <p>
                We built this app for a million reasons. Though if you<br />must
                know, I mostly did it to prove that majoring<br />in Art History
                was, in fact, 'a good idea'.
              </p>
              <p class="font-inc font-uppercase">
                <strong>- Selden Leonard</strong><br />Founder & CEO of
                <i>Art U</i>
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
    <strong>
      <div class="divider py-1 bg-dark"><hr /></div>
    </strong>
  </div>
</template>

<style></style>

<script>
export default {
  data: function() {
    return {
      message: "",
    };
  },
  created: function() {},
  methods: {},
};
</script>
